import React, { useCallback, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import { StudioIconRail } from '../../studio/components/StudioIconRail';
import { StudioCreateModal } from '../../studio/components/StudioCreateModal';

export type StudioShellOutletContext = {
  openStudioCreate: () => void;
};

function isDocumentPrintPath(pathname: string): boolean {
  return /\/imprimir\/?$/.test(pathname) || /\/studio\/print\//.test(pathname);
}

/**
 * Shell Studio estilo Micelio: icon rail + canvas a ancho completo.
 * Tokens visuales vía [data-studio-surface="micelio"].
 * Rutas de impresión van en modo documento (sin rail ni chrome web).
 */
export function StudioSoftShell() {
  const { pathname } = useLocation();
  const [createOpen, setCreateOpen] = useState(false);

  /** Curso y asignatura comparten el chrome “submundo” (hero, section bar, workspace). */
  const isCourseSubworld =
    /^\/studio\/curso\/[^/]+/.test(pathname) ||
    /^\/studio\/asignatura\/[^/]+/.test(pathname);
  const isPrintDocument = isDocumentPrintPath(pathname);

  const openStudioCreate = useCallback(() => setCreateOpen(true), []);

  if (isPrintDocument) {
    return (
      <div
        data-studio-surface="micelio"
        data-sala-theme="light"
        data-print-document="true"
        className="studio-app-shell studio-app-shell--print-document"
      >
        <div className="studio-app-work studio-app-work--print-document min-w-0 flex-1">
          <div className="studio-app-canvas studio-app-canvas--print-document">
            <Outlet context={{ openStudioCreate } satisfies StudioShellOutletContext} />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      data-studio-surface="micelio"
      data-sala-theme="light"
      {...(isCourseSubworld ? { 'data-studio-context': 'course' } : {})}
      className="studio-app-shell"
    >
      <StudioIconRail onBuild={openStudioCreate} />
      <div className="studio-app-work min-w-0 flex-1">
        <div className="studio-app-canvas micelio-scroll">
          <Outlet context={{ openStudioCreate } satisfies StudioShellOutletContext} />
        </div>
      </div>
      <StudioCreateModal open={createOpen} onOpenChange={setCreateOpen} />
    </div>
  );
}
